module.exports = __webpack_public_path__ + "static/media/matchedpeople.4c50e946.PNG";